import React from 'react';
import { Box, Flex } from 'rebass/styled-components';
import { Button } from '@getro/rombo';
import { ListRestart, SidebarClose } from 'lucide-react';
import PropTypes from 'prop-types';
import { ContactsFilters } from '../../components/organisms/contactsFilters';

export const ContactsSidebar = ({
  activeNetwork,
  dataCount,
  filtersCount,
  showListFilters,
  queryParams,
  onSetFilters,
  list,
  onCreateList,
  onResetFilters,
  showFiltersBottomBar,
  filtersTitle,
  toggleFilters,
  type,
  page,
  isLoadingOrFetching,
  showTalentNetworkFilters,
  customFields,
}) => {
  if (dataCount === 0 && filtersCount === 0 && !isLoadingOrFetching) {
    return null;
  }

  return (
    <Box
      sx={{
        maxWidth: '264px',
        position: 'relative',
        borderRight: '1px solid',
        borderColor: 'border.subtle',
        height: '100%',
      }}
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        width="24px"
        height="24px"
        color="neutral.400"
        sx={{ cursor: 'pointer', position: 'absolute', top: '4px', right: '12px', zIndex: 11000 }}
        onClick={toggleFilters}
      >
        <Box
          as={SidebarClose}
          className="main-menu-item"
          width="16px"
          height="16px"
          aria-hidden="true"
          flex="0 0 auto"
        />
      </Flex>
      <Box flex="0 0 auto" sx={{ position: 'relative', height: '100%' }}>
        <ContactsFilters
          activeNetwork={activeNetwork}
          showListFilters={showListFilters}
          page={page}
          filters={queryParams.filters}
          setFilters={onSetFilters}
          sharedList={list}
          extendedMode={type !== 'public'}
          filtersTitle={filtersTitle}
          showTalentNetworkFilters={showTalentNetworkFilters}
          customFields={customFields}
          type={type}
          sx={{
            height: '100%',
            maxHeight: showFiltersBottomBar ? 'calc(100vh - 160px)' : '100%',
          }}
        />
        {showFiltersBottomBar && (
          <Box
            width="263px"
            pt="8px"
            sx={{
              overflow: 'hidden',
              zIndex: 1000,
              position: 'absolute',
              bottom: 0,
            }}
          >
            <Flex
              bg="neutral.0"
              p="16px"
              sx={{
                minWidth: '263px',
                gap: '16px',
                boxShadow: 'medium',
                position: 'relative',
                alignItems: 'center',
                width: 'max-content',
                '&::after': {
                  content: "''",
                  width: '32px',
                  height: '10px',
                  background: 'rgb(255,255,255)',
                  // eslint-disable-next-line no-dupe-keys
                  background: 'linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)',
                  position: 'absolute',
                  top: '-10px',
                  left: 0,
                },
              }}
            >
              {showFiltersBottomBar && (
                <Button
                  sx={{
                    width: filtersCount > 0 ? 'auto' : '100%',
                    minWidth: '120px',
                    justifyContent: 'center',
                    height: '32px',
                  }}
                  icon={ListRestart}
                  iconGap="8px"
                  size="small"
                  onClick={onCreateList}
                >
                  Create list
                </Button>
              )}
              {filtersCount > 0 && (
                <Button
                  size="small"
                  variant="tertiary"
                  onClick={() => {
                    onResetFilters();
                    document.dispatchEvent(new Event('resetFilters'));
                  }}
                >
                  Clear all
                </Button>
              )}
            </Flex>
          </Box>
        )}
      </Box>
    </Box>
  );
};

ContactsSidebar.propTypes = {
  activeNetwork: PropTypes.object,
  dataCount: PropTypes.number.isRequired,
  filtersCount: PropTypes.number.isRequired,
  showListFilters: PropTypes.bool.isRequired,
  queryParams: PropTypes.object.isRequired,
  onSetFilters: PropTypes.func.isRequired,
  list: PropTypes.object.isRequired,
  onCreateList: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  filtersTitle: PropTypes.string.isRequired,
  showFiltersBottomBar: PropTypes.bool.isRequired,
  toggleFilters: PropTypes.func.isRequired,
  type: PropTypes.string,
  page: PropTypes.string.isRequired,
  isLoadingOrFetching: PropTypes.bool.isRequired,
  showTalentNetworkFilters: PropTypes.bool.isRequired,
  customFields: PropTypes.array,
};

ContactsSidebar.defaultProps = {
  activeNetwork: {},
  type: 'default',
  customFields: [],
};
